import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class PortalCommentsCount extends Field {
  static attributesForModel() {
    return ['portalCommentsCount'];
  }

  get title() {
    return 'Portal comments count';
  }

  exampleContents(): FieldContentsData {
    return { text: 4, icon: { name: 'fa-regular fa-comment' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.portalCommentsCount) {
      return {
        text: record.portalCommentsCount,
        icon: { name: 'fa-regular fa-comment' },
      };
    }

    return {};
  }
}
